import script from "./Select.vue?vue&type=script&lang=ts&setup=true"
export * from "./Select.vue?vue&type=script&lang=ts&setup=true"

import "./Select.vue?vue&type=style&index=0&id=4c457242&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c457242"]])

export default __exports__